import mixpanel from 'mixpanel-browser';

type EventProperties = {
  cameraId?: string;
  codeId?: string;
  categoryId?: string;
  codeMetadatumId?: string;
  patientId?: string;
  emergencyContactId?: string;
  monitoringHoursRuleId?: string;
};

export enum Events {
  PatientCreation = 'Patient Creation',
  PatientUpdate = 'Patient Update',
  PatientProfileView = 'Patient Profile View',
  CareInformationView = 'Care Information View',
  EmergencyContactsView = 'Emergency Contacts View',
  CameraCreation = 'Camera Creation',
  CameraDelete = 'Camera Delete',
  CameraUpdate = 'Camera Update',
  CameraMotionView = 'Camera Motion View',
  CodeCreation = 'Code Creation',
  CodeDelete = 'Code Delete',
  CodeUpdate = 'Code Update',
  CategoryUpdate = 'Category Update',
  CategoryDelete = 'Category Delete',
  CategoryCreation = 'Category Creation',
  CodeMetadataCreation = 'Code Metadata Creation',
  CodeMetadataDelete = 'Code Metadata Delete',
  CodeMetadataUpdate = 'Code Metadata Update',
  EmergencyContactCreation = 'Emergency Contact Creation',
  EmergencyContactDelete = 'Emergency Contact Delete',
  EmergencyContactUpdate = 'Emergency Contact Update',
  ReportGeneration = 'Report Generation',
  LogCreation = 'Log Creation',
  LivestreamPlay = 'Livestream Play',
  LivestreamPause = 'Livestream Pause',
  MonitoringHoursView = 'Monitoring Hours View',
  MonitoringHoursCreation = 'Monitoring Hours Creation',
  MonitoringHoursUpdate = 'Monitoring Hours Update',
  MonitoringHoursDelete = 'Monitoring Hours Delete',
}

export function initAnalytics(): void {
  const inDevelopment = import.meta.env.VITE_ENV === 'dev';
  const token = import.meta.env.VITE_MIXPANEL_TOKEN;

  if (!token) {
    throw new Error('No Mixpanel token');
  }

  // We seperate dev and prod data by using different Mixpanel projects
  mixpanel.init(token, { debug: inDevelopment });
}

/*
registerUser() isn't called in this app. Instead, similar code is user in
an Auth0 post-user-registration Action.
*/
export function registerUser(userId: string, email: string): void {
  // Link pre-identification activity using alias
  // See https://help.mixpanel.com/hc/en-us/articles/115004497803
  mixpanel.alias(userId);

  // https://help.mixpanel.com/hc/en-us/articles/115004708186-What-is-the-difference-between-Event-Properties-Super-Properties-and-People-Properties-and-which-should-I-use-
  mixpanel.people.set({
    $email: email,
  });
}

export function identify(userId: string): void {
  mixpanel.identify(userId);
}

export function unidentify(): void {
  // In order to handle multiple identities on the same device,
  // we want to call mixpanel.reset() on log out
  // See https://help.mixpanel.com/hc/en-us/articles/115004497803s
  mixpanel.reset();
}

export function track(eventName: string, eventProperties?: EventProperties): void {
  mixpanel.track(eventName, eventProperties);
}
